import curves from "../../media/layered-waves-haikei.svg";
import "../../css/userprof.css";
import { useRef, useEffect, useState } from "react";
import Swal from "sweetalert2";
import walletImg from "../../media/undraw_wallet_diag.svg"
import { auth } from "../../firebase/firebase";
import ApexCharts from "apexcharts";
import { query,where } from "firebase/firestore";
import visa from "../../media/visa2.webp"
import eth from "../../media/ethereum.png"
import paypal from "../../media/paypal.png"
import useStore from "../../store/zustandstore";
import axios from "axios";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import usefbStore from "../../store/firebasestore";
import solaralogo from "../../media/layered-peaks-haikei (1).svg"


function Userprofile() {
  const authStatus = usefbStore((s) => s.authStatus);
  const uplGraph = useRef(null);
  const transactions = usefbStore((s)=>s.transactions);
  const accountVerified = usefbStore((s)=>s.accountVerified);
  const leftProfActive = useStore((s) => s.leftProfActive);
  const userName = usefbStore((s)=>s.userName)
  const userEmail = usefbStore((s)=>s.userEmail)
  const userID = usefbStore((s)=>s.userID)
  const setTrxnDet = useStore((s)=>s.setTrxnDet)
  const setEarningsPercentage = usefbStore((s)=>s.setEarningsPercentage)
  const setTotalTasksAllTime = usefbStore((s)=>s.setTotalTasksAllTime)
  const paymentMethodSet = usefbStore((s)=>s.paymentMethodSet)
  const [trxnArray,setTrxnArray]= useState([])
  const rightProfActive = useStore((s) => s.rightProfActive);
  const accountBalance = usefbStore((s)=>s.accountBalance)
  const bankDetails = usefbStore((s)=>s.bankDetails)
  const cryptoDetails = usefbStore((s)=>s.cryptoDetails)
  const paypalDetails = usefbStore((s)=>s.paypalDetails)
  const paymentMethod = usefbStore((s)=>s.paymentMethod)
  const [availableYears, setAvailableYears] = useState([]);
  const [graphYear, setGraphYear] = useState(new Date().getFullYear().toString())
  const [fname,setFname] = useState("")
  const setTransID = usefbStore((s)=>s.setTransID)



  useEffect(() => {
    if (authStatus == "authenticated") {
      const fetchTaskStats = async () => {
        try {
          if (!userID) return;

          const creationTime = auth.currentUser.metadata.creationTime;
          const signupYear = new Date(creationTime).getFullYear();
          const currentYear = new Date().getFullYear();
          
          const years = [];
          for (let year = signupYear; year <= currentYear; year++) {
            years.push(year);
          }
          setAvailableYears(years);

          const taskStatsRef = collection(db, "Users", userID, "taskStats");
          const yearQuery = query(taskStatsRef, where("year", "==", parseFloat(graphYear)));
          const querySnapshot = await getDocs(yearQuery);
          
          const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
          const tasksCompletedData = new Array(12).fill(0);
          const totalEarningsData = new Array(12).fill(0);
          
          querySnapshot.forEach((doc) => {
            const data = doc.data();
            const month = data.month;
            const monthIndex = months.indexOf(month);
            
            if (monthIndex !== -1) {
              const tasksCompletedValue = data.taskCompleted || data.tasksCompleted || 0;
              const earningsValue = data.totalEarnings || 0;
              tasksCompletedData[monthIndex] = tasksCompletedValue;
              totalEarningsData[monthIndex] = Number(earningsValue.toFixed(2));
            }
          });

          let totalTasksCompletedAllTime = 0;
          for (let year = signupYear; year <= currentYear; year++) {
            const yearQueryAll = query(taskStatsRef, where("year", "==", year));
            const yearSnapshot = await getDocs(yearQueryAll);
            
            yearSnapshot.forEach((doc) => {
              const data = doc.data();
              const tasksValue = data.taskCompleted || data.tasksCompleted || 0;
              totalTasksCompletedAllTime += tasksValue;
            });
          }
          setTotalTasksAllTime(totalTasksCompletedAllTime);

          const currentDate = new Date();
          const currentMonth = currentDate.getMonth();
          const currentMonthEarnings = totalEarningsData[currentMonth];
          
          let previousMonthEarnings = 0;
          let previousMonthIndex = currentMonth - 1;
          
          if (previousMonthIndex >= 0) {
            previousMonthEarnings = totalEarningsData[previousMonthIndex];
          } else {
            const previousYear = new Date().getFullYear() - 1;
            const previousYearQuery = query(taskStatsRef, where("year", "==", previousYear));
            const previousYearSnapshot = await getDocs(previousYearQuery);
            
            previousYearSnapshot.forEach((doc) => {
              const data = doc.data();
              if (data.month === "Dec") {
                previousMonthEarnings = data.totalEarnings || 0;
              }
            });
          }
          
          const difference = currentMonthEarnings - previousMonthEarnings;

const differenceData = {
  amount: Math.abs(difference).toFixed(2),
  isPositive: difference > 0,
  isNegative: difference < 0,
  value: parseFloat(Math.abs(difference).toFixed(2)), // Round to 2 decimals
};

setEarningsPercentage(differenceData);
          
var options = {
  series: [
    {
      name: "Task done",
      data: tasksCompletedData,
    },
    {
      name: "Total paid $",
      data: totalEarningsData,
    },
  ],
  colors: ["#5EA7FA", "#2332DF"],
  chart: {
    height: "86%",
    width: "100%",
    type: "area",
  },
  dataLabels: {
    enabled: false,
  },
  toolBar: {
    enabled: false,
  },
  stroke: {
    curve: "smooth",
    width: 1,
  },
  xaxis: {
    type: "category",
    categories: months,
    labels: {
      show: false,
    },
  },
  yaxis: {
    labels: {
      formatter: (value) => value.toFixed(2),  // ← Fixed to show 2 decimals
    },
  },
  tooltip: {
    x: {
      format: "dd/MM/yy HH:mm",
    },
    y: {
      formatter: (value, { seriesIndex }) => {
        if (seriesIndex === 0) {
          return Math.round(value);
        }
        return `$${Number(value).toFixed(2)}`;
      },
    },
  },
  grid: {
    show: false,
  },
  legend: {
    show: false,
  },
};
          if (!uplGraph.current) {
            return;
          }


          
          var chart = new ApexCharts(uplGraph.current, options);
          chart.render();
          
        } catch (error) {
          console.error("Error fetching task stats:", error);
        }
      };
      
      fetchTaskStats();
    }
  }, [authStatus, graphYear]);

  useEffect(() => {
    if (!userName) return;
    const shortName = userName.trim().split(" ");
    const fname = shortName[0];
    setFname(fname);
  }, [userName]);

  const getStatusStyle = (status) => {
  switch(status) {
    case "completed":
      return { color: "#021351", background: "#22acfc17" };
    case "rejected":
    case "failed":
      return { color: "red", background: "#ff00001b" };
    default:
      return { color: "green", background: "#00ff4c1b" };
  }
};

const withdrawFunds = async () => {
  if (paymentMethodSet == null) return;

  if (paymentMethodSet === false) {
    Swal.fire(
      "Action Needed",
      "To withdraw your funds, please add a payment method.",
      "info"
    );
    return;
  }
  if (accountVerified == null) return
  if(!accountVerified){
     Swal.fire(
      "Action Needed",
      "To withdraw your funds, please verify your account.",
      "info"
    );
    return;
  }

  if (paymentMethodSet === true) {
    const { value: number } = await Swal.fire({
      title: "Withdraw Amount",
      input: "number",
      inputLabel: "Enter Amount",
      inputPlaceholder: "min $50",
      confirmButtonText: "Withdraw",
      reverseButtons: true,
      showCancelButton: true,
      allowOutsideClick: false,
      inputAttributes: {
        maxlength: "10",
        autocapitalize: "off",
        autocorrect: "off",
      },
    });

    if (!number) return;

    if (number < 50) {
      Swal.fire(
        "Invalid Amount",
        "The minimum withdraw amount is $50",
        "info"
      );
      return;
    }

    if (number > 10000) {
      Swal.fire(
        "Invalid Amount",
        "The maximum withdraw amount is $10,000",
        "info"
      );
      return;
    }

    try {
      const data = new FormData();

      // Basic withdrawal information
      data.append("uid", userID);
      data.append("name", userName);
      data.append("amount", number);
      data.append("withdrawMethod", paymentMethod);
      data.append("userEmail", userEmail);

      // Bank details
      data.append(
        "bankDetails",
        JSON.stringify(bankDetails)
      );

      // Crypto details
      data.append(
        "cryptoDetails",
        JSON.stringify(cryptoDetails)
      );

      // PayPal details
      data.append(
        "paypalDetails",
        JSON.stringify(paypalDetails)
      );

      // ==========================================
      // CONFIRMATION MESSAGE
      // ==========================================

      let confirmMessage = "";

      if (paymentMethod === "Bank Transfer") {
        confirmMessage =
          `You are requesting to withdraw $${number} via Bank Transfer to:\n\n` +
          `Bank: ${bankDetails?.bankName}\n` +
          `Account Name: ${bankDetails?.accountName}\n` +
          `Account Number: ${bankDetails?.accountNumber}`;
      }

      else if (paymentMethod === "Crypto Currency") {
        const walletAddress =
          cryptoDetails?.walletAddress || "";

        const maskedAddress =
          walletAddress.length > 10
            ? walletAddress.substring(0, 10) + "..."
            : walletAddress;

        confirmMessage =
          `You are requesting to withdraw $${number} via Crypto Currency to:\n\n` +
          `Wallet: ${maskedAddress}\n` +
          `Network: ${cryptoDetails?.network || "Ethereum (ERC-20)"}`;
      }

      else if (paymentMethod === "PayPal") {
        confirmMessage =
          `You are requesting to withdraw $${number} via PayPal to:\n\n` +
          `Account Name: ${paypalDetails?.accountName || "N/A"}\n` +
          `PayPal Email: ${paypalDetails?.email || "N/A"}`;
      }

      // ==========================================
      // CONFIRM WITHDRAWAL
      // ==========================================

      const confirmResult = await Swal.fire({
        title: "Confirm Withdrawal",
        text: confirmMessage,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        reverseButtons: true,
        confirmButtonColor: "#6a5acd",
        cancelButtonColor: "#d33",
      });

      if (!confirmResult.isConfirmed) return;

      // ==========================================
      // AUTH TOKEN
      // ==========================================

      const token =
        await auth.currentUser.getIdToken();

      // ==========================================
      // SEND REQUEST
      // ==========================================

      const resp = await axios.post(
        "https://solaraback-g1bm.onrender.com/withdrawRequest",
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      Swal.fire(
        "Success",
        "Withdraw request sent.",
        "success"
      );

      const result = resp.data;

    } catch (error) {
      const res = error.response;

      const message =
        res?.data?.msg ||
        (res?.status === 500
          ? "Server error, please try again later"
          : "Request failed");

      Swal.fire(
        "Request Failed",
        message,
        "warning"
      );
    }
  }
};

  useEffect(() => {
    if (!transactions || !Array.isArray(transactions)) {
      return;
    }
    setTrxnArray(transactions)
  }, [transactions])

  return (
    <div className="userProfWrap">
      <div
        className={`userProfLeft ${
          leftProfActive && rightProfActive ? "allProfActive" : ""
        } ${leftProfActive ? "leftProfActive" : "leftProfInActive"} `}
      >
        <div className="uplTop">
          <div className="uplCont">
            <span>Hey {fname ? fname.charAt(0).toUpperCase() + fname.slice(1).toLowerCase() : ''},</span>
            <p>Training epoch initiated. Your input directly shapes model performance, let's dive into it.</p>
          </div>
          <img src={solaralogo} alt="" />
        </div>
        <div className="uplBtm">
          <div className="uplBtmGraphIntro">
            <p>My Income</p>
            <div className="ubiSelect">
              <select 
                name="year" 
                value={graphYear}
                onChange={(e) => setGraphYear(e.target.value)}
              >
                <option value="">Select Year</option>
                {availableYears.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="uplGRraph" ref={uplGraph}>

          </div>
        </div>
      </div>
      <div
        className={`userProfRight ${
          leftProfActive && rightProfActive ? "allProfActive" : ""
        } ${rightProfActive ? "rightProfActive" : "rightProfInActive"} `}
      >
        <div className="uprTop">
          <div className="uprAccBalance">
            <div className="uprAccBlCont">
              <p>Wallet Balance</p>
              <span>${accountBalance.toLocaleString()}</span>
              <button onClick={()=>withdrawFunds()}>Withdraw</button>
            </div>
          </div>
          <div className="recentTrx">
            <div className="rtXIntro">
              <span>Transaction History</span>
            </div>
            <div className="rtxWrapper">
              {trxnArray.length <= 0 ? (
                <div className="no-transaction">
                  <img src={walletImg} alt="" />
                  <span>You've not made any withdrawals.</span>
                </div>
              ) : (
                trxnArray.map((trxn, index) => {
                  const dateObj = trxn.createdAt?.toDate();
                  const date = dateObj?.toLocaleDateString("en-US", {
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                  });
                  const time = dateObj?.toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  });
                  return (
                    <div
  className="rtxTramsaction"
  key={trxn.id}
  onClick={() => {
    setTrxnDet(true);
    setTransID(trxn.id);
  }}
>
                      <div className="rtxTLeft">
                        <div className="rtxTIcon">
                         {trxn.withdrawMethod === "Bank Transfer" ? (
  <img src={visa} alt="Bank Transfer" />
) : trxn.withdrawMethod === "PayPal" ? (
  <img src={paypal} alt="PayPal" />
) : (
  <img src={eth} alt="Crypto Currency" />
)}
                        </div>
                        <div className="rtxTIconCont">
                          <span>{trxn.withdrawMethod}</span>
                          <p>{date}</p>
                        </div>
                      </div>
                     <div className="rtxTRight">
  <span>${trxn.amountUSD}</span>
 <p style={getStatusStyle(trxn.status)}>
  {trxn.status?.replace(/^./, (letter) => letter.toUpperCase())}
</p>
</div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Userprofile;